import styled, { css } from 'styled-components';
import { colors } from 'bench-style-constants';

const successGreen = '#6DD287';

const iconBaseStyles = css`
  font-family: 'bench-icons' !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const iconShowStyles = css`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 19px 20px 20px 20px;
  display: inline-block;
  float: left;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  color: white;
  font-size: 20px;
  line-height: 0;

  i {
    vertical-align: top;
  }
`;

export const StyledNotifications = styled.div`
  .notifications {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 8px 18px;
    z-index: 170 !important;

    .notification {
      position: relative;
      box-sizing: border-box;
      box-shadow: 0px 2px 4px rgba(47, 48, 52, 0.2);
      border-radius: 8px;
      width: 240px;
      margin-bottom: 10px;
      color: #545454;
      -webkit-font-smoothing: antialiased;

      .notification-content {
        position: relative;
        padding: 18px;
        font-size: 14px;
        line-height: 1.4;
      }

      &.ng-enter {
        transition: 300ms ease opacity, 300ms ease transform;
        opacity: 0;
        transform: scale(0.85);
      }

      &.ng-enter.ng-enter-active {
        opacity: 1;
        transform: scale(1);
      }

      &.ng-leave {
        transition: 300ms ease opacity, 300ms ease transform;
        opacity: 1;
        transform: scale(1);
      }

      &.ng-leave.ng-leave-active {
        opacity: 0;
        transform: scale(0.85);
      }

      .bl-loading-spinner {
        display: none;

        &.show {
          display: inline-block;
        }

        circle {
          stroke: #fff;
        }
      }

      .text {
        vertical-align: top;
      }

      .icon {
        display: none;
      }

      .progress {
        display: none;
      }

      .notification-action {
        display: none;
        width: 100%;
        border: 0;
        appearance: none;
        -webkit-appearance: none;
        font-family: inherit;
        line-height: inherit;
        font-size: 14px;
        border-top: 1px solid #f4f4f4;
        padding: 10px;
        text-align: center;
        color: ${colors.water};
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        background-color: white;

        &:hover {
          color: white;
          background-color: ${colors.water};
          cursor: pointer;
          border-color: ${colors.water};
        }
      }

      &.hasAction {
        .notification-action {
          display: block;
        }

        .icon {
          border-bottom-left-radius: 0px !important;
        }
      }

      .icon-show {
        ${iconShowStyles}
      }

      &.type- {
        &default {
          background-color: white;
        }

        &loading {
          background-color: #545454;
          color: white;

          .notification-content {
            padding-left: 58px;
          }

          .bl-loading-spinner {
            position: absolute;
            left: 20px;
            top: 22px;
          }
        }

        &progress {
          font-size: 12px;
          background-color: white;

          .notification-content {
            padding-left: 78px;
          }

          .progress {
            display: block;
            height: 3px;
            margin-top: 4px;
            border-radius: 1px;
            background-color: #f4f4f4;

            &-bar {
              background-color: ${colors.water};
              height: 100%;
              border-radius: 1px;
              width: 0;
              transition: width 300ms ease-out;
            }
          }

          .icon {
            ${iconShowStyles}
            color: ${colors.water};
            border-right: 1px solid #f4f4f4;

            &:before {
              ${iconBaseStyles}
              position: relative;
              left: 2px;
              content: 'K';
            }
          }
        }

        &success {
          background-color: white;

          .notification-content {
            padding-left: 78px;
          }

          .icon {
            ${iconShowStyles}
            background-color: ${successGreen};

            &:before {
              ${iconBaseStyles}
              content: "l";
            }
          }
        }

        &warning {
          background-color: white;

          .notification-content {
            padding-left: 78px;
          }

          .icon {
            ${iconShowStyles}
            background-color: ${colors.gold};

            &:before {
              ${iconBaseStyles}
              content: "G";
            }
          }
        }

        &error {
          background-color: white;

          .notification-content {
            padding-left: 78px;
          }

          .icon {
            ${iconShowStyles}
            background-color: #F16549;

            &:before {
              ${iconBaseStyles}
              content: "a";
            }
          }
        }
      }
    }
  }
`;
